export default {
  width: 45,
  height: 45,
  stroke: false,
  svg: `
    <g fill="none">
      <circle cx="22.5" cy="22.5" r="21.5" stroke="white" stroke-width="2"/>
      <path d="M31.2144 21.6339C31.881 22.0188 31.881 22.9811 31.2144 23.366L18.8929 30.4797C18.2263 30.8646 17.3929 30.3835 17.3929 29.6137L17.3929 15.3862C17.3929 14.6163 18.2263 14.1352 18.8929 14.5201L31.2144 21.6339Z" stroke="white" stroke-width="2"/>
    </g>
`,
}
